import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const StaffPlanning = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-4 compact-form">
        <h3 className="mb-4 text-white" style={{ fontSize: "1.5rem" }}>Staff Planning</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="staffRolesNeeded">
              <Form.Label>Staff Roles Needed</Form.Label>
              <Form.Control
                type="text"
                name="staffRolesNeeded"
                value={formData.staffRolesNeeded}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="numberOfPeoplePerRole">
              <Form.Label>Number of People per Role</Form.Label>
              <Form.Control
                type="number"
                name="numberOfPeoplePerRole"
                value={formData.numberOfPeoplePerRole}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3" controlId="rolePriority">
          <Form.Label>Role Priority</Form.Label>
          <Form.Control
            as="select"
            name="rolePriority"
            value={formData.rolePriority}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="essential">Essential</option>
            <option value="important">Important</option>
            <option value="niceToHave">Nice-to-have</option>
          </Form.Control>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default StaffPlanning;